
import { ContentItem, Elements } from '@kentico/kontent-delivery';
import {  resolveContentLink } from '../Utilities/ContentLinks';
/**
 * Generated by '@kentico/kontent-model-generator@3.2.0'
 
 */
export class Portal extends ContentItem {
        constructor() {
        super({
            propertyResolver: ((elementName) => {
                if (elementName === 'portal_title') {
                    return 'portalTitle';
                }
                if (elementName === 'portal_slug') {
                    return 'portalSlug';
                }
                return elementName;
            }),
            linkResolver: (link) => resolveContentLink(link)
        });
    }
}
